import { FeatureConfig } from "@/utils/constants/featuresFlag";
export const useAzureBlob = () => {

  const VITE_BLOB_URL = import.meta.env[FeatureConfig.blobURL];

  const uploadFileOnBlob = async (sasResponse, file) => {

    if (!sasResponse?.sasToken || !file) return;

    const uploadUrl = `${VITE_BLOB_URL}${sasResponse?.directory}${sasResponse?.fileName}?${sasResponse?.sasToken}`;

    try {
      const response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file?.type,
        },
        body: file,
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      return {
        message: "Success",
        media: {
          imageUrl: sasResponse?.blobUrl,
          filename: sasResponse?.fileName,
        },
      };
    } catch (error) {
      console.error("Error uploading file:", error);
      return error;
    }
  };

  const downloadFileOnBlob = async (sasResponse, fileDirectory, fileName) => {

    if (!sasResponse?.sasToken || !fileName) return;

    const uploadUrl = `${VITE_BLOB_URL}${fileDirectory}?${sasResponse?.sasToken}`;

    try {
      const response = await fetch(uploadUrl, {
        method: "GET",
        headers: {
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": "text/csv",
        },
      });

      if (!response.ok) {
        throw new Error("Download failed");
      }
      
      const responseText = await response.text();
      
      return {
        responseText,
        response
      };
    } catch (error) {
      console.error("Error uploading file:", error);
      return error;
    }
  };
  return { uploadFileOnBlob, downloadFileOnBlob };
};
